import './MyContracts.scss';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Label, Form, Button } from 'reactstrap';
import SearchInput from '../../commons/SearchInput';
import Header from '../../commons/Header';
import Footer from '../../commons/Footer';
import BurgerMenu from '../../commons/BurgerMenu';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import {
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import ContractsTable from './ContractsTable';
import { useAlert } from 'react-alert';
import ContractsImportFeedbackModal from './ContractsImportFeedbackModal';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import { useLoading } from '../../commons/Loading';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import ContractsHistoryModal from './ContractsHistoryModal';
import ExportCSVButton from './ExportCSVButton';

const ContractsPresentational = ({
  contractsImportFeedbackData,
  data,
  formattedData,
  profile,
  query,
  total,
  totPod = 0,
  totPdr = 0,
  onFilter,
  onImportContract,
  toggleShowImportFeedback,
  hasImportedContracts,
  handleFileListView,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const [{ newToken } = {}] = useAuth();
  const {
    offset,
    limit,
    customerType,
    managementStatus,
    contractStatus,
    contractType,
  } = query;
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [historyModal, setHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [contractId, setContractId] = useState(null);

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContract(data);
    }
  }

  const fetchHistoryContract = async (contractId) => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/contracts/switch-info/${contractId}`,
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data: dataResponse = [] } = response;
    setHistoryData(dataResponse.contractHistory || []);
  };

  const toggleHistoryModal = (contractId) => {
    setHistoryModal((v) => !v);
    setContractId(contractId);
  };

  useEffect(() => {
    if (historyModal && contractId) {
      fetchHistoryContract(contractId);
    } else {
      setHistoryData([]);
    }
  }, [historyModal, contractId]);

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <ContractsImportFeedbackModal
          data={contractsImportFeedbackData}
          toggle={toggleShowImportFeedback}
          isOpen={hasImportedContracts}
        />
        <ContractsHistoryModal
          isOpen={historyModal}
          toggle={toggleHistoryModal}
          data={historyData}
        />
        <section>
          <Header
            title={t('PAGES:CONTRACTS')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            <Col className="">
              <ContFlexRight>
                Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; | Contratti
                PDR:&nbsp;<strong>{totPdr}</strong>
              </ContFlexRight>
            </Col>
          </Row>

          <Row>
            <Col sm="12" md="12" lg="4" xl="4">
              <Button
                href={`/examples/Template_Contratti_Switch.csv`}
                target="_blank"
                color="primary"
                style={{ width: '100%' }}
              >
                Scarica template importazione
              </Button>
            </Col>
            <Col sm="12" md="12" lg="4" xl="4">
              <Button
                href={`/documentation/Extra_Importazione_contratti_switch.pdf`}
                target="_blank"
                color="primary"
                style={{ width: '100%' }}
              >
                Scarica documentazione importazione
              </Button>
            </Col>

            <Col sm="0" md="0" lg="1" xl="1"></Col>

            <Col sm="12" md="12" lg="3" xl="3">
              <ExportCSVButton data={formattedData} />
            </Col>

            <Col sm="0" md="0" lg="1" xl="1"></Col>
          </Row>

          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.supplier }}
                onFilter={({ search }) => onFilter({ supplier: search })}
                label={t('SEARCH:BY_SUPPLIER')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.customer }}
                onFilter={({ search }) => onFilter({ customer: search })}
                label={t('SEARCH:CUSTOMER')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.pod_pdr }}
                onFilter={({ search }) => onFilter({ pod_pdr: search })}
                label={t('SEARCH:POD_PDR')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.condo_vat_cf }}
                onFilter={({ search }) => onFilter({ condo_vat_cf: search })}
                label={t('SEARCH:TAX_CODE')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.owner }}
                onFilter={({ search }) => onFilter({ owner: search })}
                label={t('SEARCH:OWNER')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.holder }}
                onFilter={({ search }) => onFilter({ holder: search })}
                label={t('SEARCH:HOLDER_FEE')}
              />
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Tipologia cliente</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="customerType"
                        name="customerType"
                        value={customerType}
                        onChange={({ target: { value: customerType } }) =>
                          onFilter({ customerType })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="condos">Condomini</option>
                        <option value="customerExtra">Clienti privati</option>
                        <option value="utilizers">Utilizzatori</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>Stato Gestione</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="managementStatus"
                        name="managementStatus"
                        value={managementStatus}
                        onChange={({ target: { value: managementStatus } }) =>
                          onFilter({ managementStatus })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="active">ATTIVO</option>
                        <option value="terminated">TERMINATO</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>Stato Contratto</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractStatus"
                        name="contractStatus"
                        value={contractStatus}
                        onChange={({ target: { value: contractStatus } }) =>
                          onFilter({ contractStatus })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="active">ATTIVO</option>
                        <option value="terminated">TERMINATO</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Tipo contratto</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractType"
                        name="contractType"
                        value={contractType}
                        onChange={({ target: { value: contractType } }) =>
                          onFilter({ contractType })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="POD">POD</option>
                        <option value="PDR">PDR</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_SIGNIN_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectContractSigningYear"
                        name="contractSigningYear"
                        value={query && query.contractSigningYear}
                        onChange={({
                          target: { value: contractSigningYear },
                        }) => {
                          onFilter({ contractSigningYear });
                        }}
                      >
                        {generateYearOptions(true)}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_SIGNIN_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractSigningMonth"
                        name="contractSigningMonth"
                        disabled={!query.contractSigningYear}
                        value={query && query.contractSigningMonth}
                        onChange={({
                          target: { value: contractSigningMonth },
                        }) => onFilter({ contractSigningMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_END_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectContractEndYear"
                        name="contractEndYear"
                        value={query && query.contractEndYear}
                        onChange={({ target: { value: contractEndYear } }) => {
                          onFilter({ contractEndYear });
                        }}
                      >
                        {generateYearOptions(true)}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_END_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractEndMonth"
                        name="contractEndMonth"
                        disabled={!query.contractEndYear}
                        value={query && query.contractEndMonth}
                        onChange={({ target: { value: contractEndMonth } }) =>
                          onFilter({ contractEndMonth })
                        }
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" xl="3">
              <FormGroup>
                <CustomInput
                  type="file"
                  id="importFilee"
                  name="importFilee"
                  onChange={(event) => handleImportFile(event)}
                  accept=".csv"
                />
                <Label for="selectFile">
                  {t('ENERGY_CONTRACT:CHOOSE_FILE')}
                  &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </section>

        <section className="m-t-20">
          <ContractsTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            profile={profile}
            truncateTable={profile && profile._id}
            toggleHistoryModal={toggleHistoryModal}
            handleFileListView={handleFileListView}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default ContractsPresentational;
